<div class="h-[100%]">
  <ng-container *ngIf="currentStep === 1">
    <!--
      NOTE: when initially we create a project, we send it id to parent component
      so that when we go to other component and come back to previous component, we
      can get proper project id and fetch proper details
    -->
    <app-overview
      (projectIdEmitter)="receiveProjectId($event)"
      [projectId]="projectId"
    ></app-overview>
  </ng-container>
  <ng-container *ngIf="currentStep === 2">
    <app-location-and-site-condition
      [projectId]="projectId"
    ></app-location-and-site-condition>
  </ng-container>

  <ng-container *ngIf="currentStep === 3">
    <app-budget-and-timeline [projectId]="projectId"></app-budget-and-timeline>
  </ng-container>
</div>
